var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor-content',{staticClass:"editor editor2",attrs:{"data-placeholder":"コメントを入力する","editor":_vm.editor},nativeOn:{"keydown":function($event){return _vm.keydownHandler.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }